module.exports = __webpack_public_path__ + "media/category_icons/OBGYN-be7e2d1d.svg";